import { forwardRef, useEffect, useState, type FC } from "react";
import { Button, Form, Input, Modal } from "rsuite";
import { PriceCategory } from "../../../models/inventory/price_category";

interface PriceCategoryFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: PriceCategory) => void;
  priceCategory?: PriceCategory;
}

const PriceCategoryForm: FC<PriceCategoryFormProps> = ({
  open,
  onClose,
  onSubmit,
  priceCategory,
}) => {
  const [data, setData] = useState<PriceCategory>({
    id: "",
    name: "",
    description: "",
  });

  useEffect(() => {
    setData(
      priceCategory || {
        id: "",
        name: "",
        description: "",
      }
    );
  }, [priceCategory]);
  return (
    <Modal size={"lg"} open={open} onClose={onClose}>
      <Modal.Header>Price Category Form</Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="form-group">
            <label>Name</label>
            <Input
              name="name"
              placeholder="Name"
              value={data.name}
              onChange={(value, event) => setData({ ...data, name: value })}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <Input
              as={"textarea"}
              rows={5}
              name="description"
              placeholder="Description"
              value={data.description}
              onChange={(value, event) =>
                setData({ ...data, description: value })
              }
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button
            appearance="primary"
            onClick={() => {
              onSubmit(data!);
              setData({
                id: "",
                name: "",
                description: "",
              });
            }}
          >
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default PriceCategoryForm;
